import { getCountry } from '../utils/TranslationUtils';
import { flags, processFlags } from './flags';

const AppInitialState = {
    formsSection: {
        containerClass: (window.location.search.includes("zip_code") ? '' : 'show'),
        validation: {
            firstName: {
                class: "",
                msg: ""
            },
            lastName: {
                class: "",
                msg: ""
            },
            localName: {
                class: "",
                msg: ""
            },
            email: {
                class: "",
                msg: ""
            },
            phone: {
                class: "",
                msg: ""
            },
            zip: {
                class: "",
                msg: ""
            },
            province: {
                class: "",
                msg: ""
            },
            cities: {
                class: "",
                msg: ""
            },
        }
    },
    carSection: {
        containerClass: (window.location.search.includes("zip_code") ? 'show' : '')
    },
    timeSection: {
        containerClass: '',
        data: null,
        model: null
    },
    confirmationSection: {
        containerClass: '',
        values: {}
    },
    driverlicenseSection: {
        containerClass: '',
        buttonStatus: 'disabled'
    },
    flags: processFlags(flags, getCountry()),
}

export function InitialState() {
    return AppInitialState;
}